<template>
	<div>
		<!-- Discount Section -->
		<discount v-if="$mq == 'lg'" :config="config"></discount>

		<!-- Select Package Section -->
		<section
			class="container-fluid checkout my-4 my-md-5"
			v-if="config.products.packages.length"
		>
			<div class="container p-0 px-sm-4">
				<div class="row">
					<div class="col-12 col-md-6 col-lg-7">
						<!-- Mobile Discount Section -->
						<countdown
							v-if="$mq === 'sm'"
							:countdown="config.countdown"
							:discount="discount.percent"
							class="mb-4"
						></countdown>

						<select-package
							:products="config.products"
							:checkoutPath="checkoutPath"
							:beacon="beacon"
							@changePackage="updatePackages"
						></select-package>

						<div class="checkout-block rounded">
							<extras
								:extras="config.extras"
								:discount="discount.percent"
								:checkoutPath="checkoutPath"
								:beacon="beacon"
								@changeExtras="updateExtras"
							></extras>
						</div>
					</div>
					<div class="col-12 col-md-6 col-lg-5 sidebar-container">
						<div class="sidebar sidebar-inner">
							<div
								class="checkout-block rounded pb-0 mb-4"
								v-if="config.video.widgetEnabled"
							>
								<promo-video
									:video="config.video"
								></promo-video>
							</div>

							<div
								class="checkout-block rounded pb-0 mb-4"
								v-if="config.countdown.widgetEnabled"
							>
								<countdown
									v-if="$mq === 'lg'"
									:countdown="config.countdown"
									:discount="discount.percent"
								></countdown>
							</div>

							<div
								class="checkout-block rounded pb-0 mb-4"
								v-if="config.images.widgetEnabled"
							>
								<images :images="config.images"></images>
							</div>

							<div class="checkout-block rounded pb-0 mb-4">
								<sum
									:checkoutPath="checkoutPath"
									:beacon="beacon"
									:prices="prices"
									:discount="discount.percent"
									:locale="config.locale"
								></sum>
							</div>

							<div class="checkout-block rounded pb-0">
								<reviews
									:reviews="config.reviews"
									:locale="config.locale"
								></reviews>
							</div>

							<span
								style="display: none"
								id="precheckout_url"
								:data-url="checkoutPath"
							></span>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
/*  
    TEST ON SHOPIFY
    Add PROOF Popup
    Add Exit pop
    Add custom push notifiactions (own server or smaller companies) */

import Discount from "./sections/Discount"
import SelectPackage from "./sections/SelectPackage"
import Extras from "./sections/Extras"
import Reviews from "./sections/Reviews"
import Sum from "./sections/Summary"
import Countdown from "./sections/Countdown"
import Images from "./sections/Images"
import PromoVideo from "./sections/Video"

import ResizeSensor from "resize-sensor"
window.ResizeSensor = ResizeSensor
import StickySidebar from "sticky-sidebar"

export default {
	components: {
		Discount,
		SelectPackage,
		Extras,
		Reviews,
		Sum,
		Countdown,
		Images,
		PromoVideo,
	},
	data() {
		return {
			packagePath: "",
			extrasPath: "",
			discount: {
				percent: 0,
				code: "",
			},
			prices: {
				packageCosts: 0,
				packageSavings: 0,
				extraCosts: 0,
				extraSavings: 0,
			},
		}
	},
	computed: {
		config() {
			return window.config
		},
		checkoutPath() {
			return (
				this.packagePath +
				this.extrasPath +
				"/?discount=" +
				this.discount.code +
				this.trackingCode +
				this.googleTrackingCode
			)
		},
		beacon() {
			return this.config.beacon !== undefined
				? this.config.beacon
				: { send: false, url: "" }
		},
		trackingCode() {
			let urlParams = new URLSearchParams(window.location.search)
			let trk = urlParams.get("lpt")

			// Get tracking code from query string
			if (trk && typeof trk === "string" && trk.length > 5) {
				this.setCookie("lpt", trk, 14)
				return "&lpt=" + trk
			} else {
				return ""
			}
		},
		googleTrackingCode() {
			let urlParams = new URLSearchParams(window.location.search)
			let ga = urlParams.get("_ga")

			// Get tracking code from query string
			if (ga && ga.length > 10) {
				return "&_ga=" + ga
			} else {
				return ""
			}
		},
	},
	methods: {
		updatePackages(p) {
			// Add product package
			this.packagePath = "https://shop.ohowatch.com/cart/" + p.path
			this.discount = p.discount
			this.$emit("discount-changed", p.discount.percent)
			this.prices.packageCosts = p.costs
			this.prices.packageSavings = p.savings
		},
		updateExtras(e) {
			// Add extras to the path
			if (this.packagePath.length > 0) {
				this.extrasPath = e.path
			}

			this.prices.extraCosts = e.costs
			this.prices.extraSavings = e.savings
		},
		setCookie(cname, cvalue, exdays) {
			var d = new Date()
			d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
			var expires = "expires=" + d.toUTCString()
			var cookie = this.getCookie(cname)

			if (
				cookie === false ||
				cookie == "" ||
				cookie == null ||
				cookie == undefined
			) {
				document.cookie =
					cname + "=" + cvalue + ";" + expires + ";path=/"
			}
		},
		getCookie(cname) {
			var name = cname + "="
			var decodedCookie = decodeURIComponent(document.cookie)
			var ca = decodedCookie.split(";")
			for (var i = 0; i < ca.length; i++) {
				var c = ca[i]
				while (c.charAt(0) == " ") {
					c = c.substring(1)
				}
				if (c.indexOf(name) == 0) {
					return c.substring(name.length, c.length)
				}
			}
			return false
		},
	},
	mounted() {
		if (this.$mq === "lg") {
			new StickySidebar(".sidebar", {
				containerSelector: ".sidebar-container",
				innerWrapperSelector: ".sidebar__inner",
				topSpacing: 20,
				bottomSpacing: 20,
				resizeSensor: true,
			})
		}
	},
}
</script>

<style lang="scss"></style>
